import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Route guard for the /admin/* pages.
 *
 * COSMETIC ONLY. `is_admin` comes from localStorage and is trivially forged in
 * devtools — this exists so a non-admin doesn't see a broken page, not to
 * protect anything. The real gate is the router-level `Depends(require_admin)`
 * on webapp/api/admin.py, which re-reads the user row on every request.
 */
export default function RequireAdmin({
  children,
}: {
  children: React.ReactElement;
}) {
  const { user } = useAuth();
  if (!user?.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
